<button class="icon-left" mat-icon-button [matMenuTriggerFor]="dateFilterMenu" aria-label="Filter">
    <mat-icon [ngClass]="{'material-icons-outlined' : !hasFilterSelected()}">filter_alt</mat-icon>
</button>
<mat-menu #dateFilterMenu="matMenu">
    <div class="menuContainer" (click)="$event.stopPropagation()">
        <div>
            <button class="clear-button" mat-icon-button (click)="clearFilters()">
                <div class="icon-container">
                    <mat-icon>block</mat-icon>
                </div>
                <span class="text-container">Clear filter</span>
            </button>
        </div>
        <div>
            <mat-form-field class="date-input lc-form-field" appearance="outline">
                <mat-label class=date-input-label>Choose a date</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="filter.date" (dateChange)="invokeSelectionChanged()">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
        <div>
            <mat-checkbox class="checkbox" [(ngModel)]="filter.isEqualTo" (change)="invokeSelectionChanged()">Equal To</mat-checkbox>
        </div>
        <div>
            <mat-checkbox class="checkbox" [(ngModel)]="filter.isGreaterThan" (change)="invokeSelectionChanged()">Greater Than</mat-checkbox>
        </div>
        <div>
            <mat-checkbox class="checkbox" [(ngModel)]="filter.isLessThan" (change)="invokeSelectionChanged()">Less Than</mat-checkbox>
        </div>
    </div>
</mat-menu>